export const GOOGLE_MAPS_API_KEY = 'AIzaSyDC-GKCgs_ysEGjiETUzaycZCRma_sK5lo';
